import React from "react";

const GeneralPdf = ({ title, pdf_link }) => {
    return (
        <div style={{ width: '100vw', height: '100vh' }}>
            <embed
                src={pdf_link}
                type="application/pdf"
                width="100%"
                height="100%"
                style={{ border: "none" }}
                onError={() => window.open(pdf_link, "_blank")}
            />
            <noscript>
                <a href={pdf_link} target="_blank" rel="noopener noreferrer">View PDF</a>
            </noscript>
        </div>

    );
};

export default GeneralPdf;
